import React from "react";
import { Button } from "../../../../ui/components/Button";
import {
  DOCUMENT_CATEGORY_OPTIONS,
  DocumentCategory,
} from "./documentFilters";

interface DocumentTypeFilterPillsProps {
  value: DocumentCategory;
  onChange: (value: DocumentCategory) => void;
}

export const DocumentTypeFilterPills: React.FC<DocumentTypeFilterPillsProps> = ({
  value,
  onChange,
}) => {
  return (
    <div className="flex items-center gap-2">
      {DOCUMENT_CATEGORY_OPTIONS.map((option) => (
        <Button
          key={option.value}
          className="rounded-full"
          variant={value === option.value ? "brand-primary" : "neutral-secondary"}
          size="small"
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
};
